import { render, staticRenderFns } from "./OffersFlash.vue?vue&type=template&id=1c0014c0&scoped=true"
import script from "./OffersFlash.vue?vue&type=script&lang=js"
export * from "./OffersFlash.vue?vue&type=script&lang=js"
import style0 from "./OffersFlash.vue?vue&type=style&index=0&id=1c0014c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0014c0",
  null
  
)

export default component.exports